var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCommentOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#comment_off_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#B8BCC8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M8.5 18.95H8c-4 0-6-.998-6-5.983V7.982Q2 2 8 2h8q6 0 6 5.982v4.985q0 5.982-6 5.982h-.5c-.31 0-.61.15-.8.399l-1.5 1.994a1.426 1.426 0 0 1-2.4 0l-1.5-1.994c-.2-.24-.49-.379-.8-.399"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 11,
  r: 1,
  fill: "#B8BCC8"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 11,
  r: 1,
  fill: "#B8BCC8"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 11,
  r: 1,
  fill: "#B8BCC8"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "comment_off_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgCommentOff;